// {%- comment -%}2024-12-18 Paul N. add next-incoming-date block customization{%- endcomment -%}
// {%- comment -%}the text|label could probably be static text{%- endcomment -%}
class ProductNextIncomingDate extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.initialAvailability = "true" === this.dataset.initialAvailability)
    ,(this.initialNextIncomingDate = this.dataset.initialNextIncomingDate)
    ,(this.hasOnlyDefaultVariant = "true" === this.dataset.hasOnlyDefaultVariant)
    ,(this.textContainer = this.querySelector("span"))
    ,(this.text = this.dataset.text)
    /*, (this.initial_quantity = parseInt(this.dataset.initialQuantity))*/
    /*, (this.threshold = parseInt(this.dataset.threshold))*/
    //, 
    ;
    if (!this.text && typeof(theme) == 'object') {
      this.text = theme.translations.next_incoming_date;
    }
    if (!this.hasOnlyDefaultVariant) {
      (this.variants_json = JSON.parse( this.querySelector("#product-next-incoming-date--json").innerHTML));
    }

    // INIT
    this.initialAvailability ? this.show(false) : this.update(this.initialNextIncomingDate);
    // this.initialAvailability ? this.update(this.initialNextIncomingDate) : this.show(!1);

    if (!this.hasOnlyDefaultVariant) {
      this.eventName = `theme:product:${this.dataset.id}:variantChanged`;
      this.updateListener(this.eventName);
    }
    //console.log('connected');
    //console.log(`theme:product:${this.dataset.id}:variantChanged`);
  }
  updateListener(eventName) {
    console.log("name "+eventName);
    // , available: available , next_incoming_date: next_incoming_date
    window.addEventListener(this.eventName,({ detail: { variant: variant } }) => {
      debugger
      //console.log(`triggered theme:product:${this.dataset.id}:variantChanged`);
      console.log(variant.id);
      if (!this.variants_json) return;
      //if (available) return;
      let currentVariant;
      variant && (currentVariant = this.variants_json.find(currentVariant => currentVariant.id === variant.id))
        ? this.update(currentVariant.next_incoming_date)
        : this.show(false);
    });
  }
  update(next_incoming_date) {
    if(!next_incoming_date) { this.show(false); return; }
    // ReferenceError: theme is not defined let i = theme.translations.next_incoming_date ?? "Expected: ";
    if(next_incoming_date) {
      this.textContainer.innerText = this.text +' ' + next_incoming_date;
    }

  }
  show(has_next_incoming_date) {
    this.parentNode.setAttribute("aria-hidden", !has_next_incoming_date);
  }
}
const productNextIncomingDateEl = customElements.get("product-next-incoming-date-root");
productNextIncomingDateEl || customElements.define("product-next-incoming-date-root", ProductNextIncomingDate);